<template>
  <div class="msupeript">
    <input class="ipt" :type="type" :readonly="readonly" :value="value"  />
  </div>
</template>
<script>
export default {
    props:{
        value:String,
        rule:{
        
        },
        type:{
            type:[String],
            default:"text"
        },
        defaultInfo:String,
        readonly:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            info:""
        }
    },
    methods:{
        
    }
};
</script>
<style lang="scss" scoped>
.msupeript {
  position: relative;
  width: 100%;
  height: 100%;
  .ipt {
    position: absolute;
    box-sizing: border-box;
    font-size: inherit;
    height: 100%;
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
  }
  .errorInfo{
    position: absolute;
    width: 100%;
    color: red;
    transform: translateY(100%);
    bottom: 0;
  }
}
</style>